

import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactEcharts from "echarts-for-react";
import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primereact/resources/primereact.css';
import StudentCharacteristics_bannerImg from "../../assets/images/StudentCharacteristics_banner.jpg"
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStudent_Characteristics, fetchStudent_Characteristics_Line, fetchStudent_Group
} from '../../redux/slices/counter';
import LoaderContainer from "../../components/LoaderContainer/LoaderContainer";
import { formatNumber } from "./enrollment.component";


export default function StudentCharacteristics() {
  const dispatch = useDispatch();
  const Student_Characteristicsdata = useSelector(state => state.netsales.Student_Characteristics);
  // loaders
  const Student_Characteristicsloadingdata = useSelector(state => state.netsales.Student_Characteristicsloading);
  const Student_Grouploadingdata = useSelector(state => state.netsales.Student_Grouploading);

  const Student_Characteristics_Linedata = useSelector(state => state.netsales.Student_Characteristics_Line);

  const appliedfilter = useSelector(state => state.filter.appliedFilters);


  let Student_Groupdata = useSelector(state => state.netsales.Student_Group);
  const sortedStudent_Characteristicsdata = [...Student_Characteristicsdata]?.sort((a, b) => {

    return b.VALUE - a.VALUE;
  });
  const sortedData = [...Student_Groupdata]?.sort((a, b) => {

    return b.VALUE - a.VALUE;
  });

  useEffect(() => {
    dispatch(fetchStudent_Characteristics({
      "elasticQueryName": "Student_Characteristics",
      "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
      "dynamicColumns": [],
    }));
    dispatch(fetchStudent_Group({
      "elasticQueryName": "Student_Group",
      "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
      "dynamicColumns": [],
    }));
    dispatch(fetchStudent_Characteristics_Line({
      "elasticQueryName": "Student_Group",
      "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
      "dynamicColumns": [{
        "columnName": "#{year_filter}",
        "columnValue": "and SCHOOL_YEAR BETWEEN (2025 -2 ) AND 2025"
      }],
    }));
  }, []);


  const [screenWidth, setScreenWidth] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== 'undefined') {
        const screenWidth = window.innerWidth;
        setScreenWidth(screenWidth);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  const StudentCharacteristics = {
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(50,50,50,0.7)',
      borderColor: "#333",
      textStyle: {
        fontSize: 12,
        fontWeight: "normal",
        color: '#fff',
      },
      axisPointer: {
        type: 'shadow'
      },
      // formatter: function (params) {
      //   const dataPoint = sortedStudent_Characteristicsdata?.find(d => d.LABEL === params.name);

      //   if (dataPoint) {
      //     return `${params.marker} ${params.name}: <b>${dataPoint?.VALUE?.toLocaleString()} (${dataPoint.PERCENTAGE}%)</b>`;
      //   }
      //   return `${params.marker} ${params.name}: ${params.value?.toLocaleString()}`;
      // },
      formatter: function (params) {
            const { value, percentage } = params.data
            if (percentage) {
               return `${params.marker} ${params.name}: <b>${value.toLocaleString()} (${percentage}%)</b><br/>`;
            } else {
                return `${params.marker} ${params.name}: ${params.value?.toLocaleString()}<br/>`;
            }
      },

    },
    grid: {
      left: '5%',
      bottom: '15%',
      top: "0%",
      right: '15%',
      height: '100%',
      containLabel: true,
      animation: false,
    },

    yAxis: [
      {
        type: 'category',
        data: sortedStudent_Characteristicsdata?.map(itr => itr.LABEL === "Economically Disadvantaged" ? "Free and Reduced Lunch" : itr?.LABEL === "Students with Disability" ? "Students with Disabilities" : itr.LABEL == 'English Learners' ? 'EL' : itr?.LABEL),
        inverse: true,
        axisLine: {
          show: false,
          lineStyle: {
            color: '#E3E3E3'
          }
        },
        axisLabel: {
          color: '#fff',
          fontSize: '10.5',
          fontWeight: "normal",
          position: 'insideRight',
        },
        axisTick: {
          show: false,
        },
      },
    ],

    xAxis: {
      type: 'value',
      axisLabel: {
        show: false,
      },
      inverse: true,
      splitLine: {
        show: false,
        lineStyle: {
          type: "dashed"
        },
      },
      // min: 0,
      // max: 15000,
      // interval: 10,
    },

    series: [
      {
        label: {
          show: true,
          position: 'right',  // Places label inside, aligned left
          fontSize: 11,
          // formatter: function (params) {
          //   const NumberConvert = formatNumber(params.value)
          //   return NumberConvert

          // },
          "textStyle": {
            "color": "#fff"
          }
        },
        emphasis: {
          focus: 'series'
        },
        // data: sortedStudent_Characteristicsdata.map(itr => itr.VALUE),
        data: sortedStudent_Characteristicsdata?.map(itr => {
          return {
              value: itr.VALUE,
              percentage: itr.PERCENTAGE ?? null
          }
      }),
        type: 'bar',
        barWidth: "80%",
        color: '#79543A',
        itemStyle: {
          normal: {
            barBorderRadius: [3, 3, 3, 3],
            color: '#79543A',
          }
        }

      }
    ]
  };


  const memoizedChartOption = useMemo(() => StudentCharacteristics, [sortedStudent_Characteristicsdata]);


  const SchoolDistrictEmployeesnew = {
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(50,50,50,0.7)',
      borderColor: "#333",
      textStyle: {
        fontSize: 12,
        fontWeight: "normal",
        color: '#fff',
      },
      axisPointer: {
        type: 'shadow'
      },
      formatter: function (params) {
        const dataPoint = sortedData?.find(d => d.LABEL === params.name);

        if (dataPoint) {
          return `${params.marker} ${params.name}: ${dataPoint?.VALUE?.toLocaleString()} (${dataPoint.PERCENTAGE}%)`;
        }
        return `${params.marker} ${params.name}: ${params.value}`;
      }
    },
    grid: {
      left: '6%',
      bottom: '0%',
      top: "7%",
      right: '15%',
      height: 200,
      containLabel: true, animation: false,
    },

    yAxis: [
      {
        type: 'category',
        position: "left",
        inverse: true,
        // data: ['Prekindergarten', 'Kindergarten', 'Elementary', 'Secondary','Ungraded'],
        data: [...new Set(sortedData?.map(item => item["LABEL"]))],
        axisLine: {
          show: false,
          lineStyle: {
            color: '#E3E3E3'
          }
        },
        axisLabel: {
          color: '#fff',
          fontSize: 11,
          fontWeight: "normal",
          position: 'insideLeft',
        },
        axisTick: {
          show: false,
        },
      },
    ],

    xAxis: {
      show: false,
      // inverse: false,
      // min: 0,
      // max: 17000,
      // interval: 5,
      axisLabel: {
        show: true
      }
    },

    series: [
      {
        label: {
          normal: {
            show: true,
            position: "right",
            fontSize: 11,
            // padding: 10,
            formatter: function (params) {
              const NumberConvert = formatNumber(params.value)
              return NumberConvert

            },
            "textStyle": {
              "color": "#fff"
            }
          }
        },
        emphasis: {
          focus: 'series'
        },
        // data: [29.12, 25, 360.09, 295.64,119.47],
        // data: [257, 26.00, 358.85, 297.41,119.40],
        data: sortedData?.map(item => item["VALUE"]),
        type: 'bar',
        barWidth: "80%",
        color: '#79543A',
        itemStyle: {
          normal: {
            barBorderRadius: [3, 3, 3, 3],
            color: '#79543A',
          }
        }

      }
    ]
  };

  const memoizedChartOption1 = useMemo(() => SchoolDistrictEmployeesnew, [sortedData]);

  const MyChart = React.memo(({ options }) => {
    return <ReactEcharts option={options} notMerge={true} lazyUpdate={true} style={{ width: '100%', height: screenWidth <= 1450 && screenWidth >= 1100 ? 200 : 210 }} />;
  });


  return (
    <div className="bg-[#0F0D0B] text-[#fff] h-[100%] rounded-[7px]">
      <div className="relative h-[190px]">
        <div className=" h-[180px] ">
          <img src={StudentCharacteristics_bannerImg} className="h-[190px] w-full " alt="banner-img" />
        </div>
        <div className="w-full absolute bottom-0 h-[40px] bg-[#0f0d0bb3] py-2 px-3">
          <h3 className="text-[16.2px] text-[#fff]">Student Characteristics</h3>
        </div>
      </div>
      <LoaderContainer height={"150px"} width={"100%"} loading={Student_Characteristicsloadingdata} className="StudentCharacteristics mt-2 mb-2">

        <div className="StudentCharacteristics bg-[#0F0D0B] pb-2 pt-2">
          <MyChart options={memoizedChartOption} />

        </div>
      </LoaderContainer>
      <div className="border-t pt-5 border-[#ffffff26]  bg-[#0F0D0B]">
        <LoaderContainer height={"195px"} width={"100%"} loading={Student_Grouploadingdata} className="StudetGroup">

          <div className="StudetGroup">
            <div className="text-white text-[14.2px] text-left mx-3">Ethnicity</div>
            {/* <ReactEcharts option={StudentGroup} /> */}
            <MyChart options={memoizedChartOption1} />
          </div>
        </LoaderContainer>
      </div>

    </div>
  )
}